// extracted by mini-css-extract-plugin
module.exports = {"header":"d1b17f","headerImageDesktop":"_06bd51","headerImageMobile":"_1363fe"};